import i18n from 'i18next';

import { invoiceDataTranslations, paymentHistoryTranslations, subscriptionsTranslations } from './index';

/**
 * Register Subscriptions Domain Translations
 *
 * Registers translations directly into i18next instance.
 * Called once at domain load/app initialization.
 */
export const registerSubscriptionsTranslations = (): void => {
  Object.entries(subscriptionsTranslations).forEach(([language, resources]) => {
    i18n.addResourceBundle(language, 'subscriptions', resources, true, true);
  });

  Object.entries(paymentHistoryTranslations).forEach(([language, resources]) => {
    i18n.addResourceBundle(language, 'paymentHistory', resources, true, true);
  });

  Object.entries(invoiceDataTranslations).forEach(([language, resources]) => {
    i18n.addResourceBundle(language, 'invoiceData', resources, true, true);
  });
};

/**
 * Check if Subscriptions Translations are loaded
 *
 * @param language - Language to check (defaults to current i18n language)
 * @returns True if translations are loaded
 */
export const areSubscriptionsTranslationsLoaded = (language?: string): boolean => {
  const lng = language || i18n.language;
  return (
    i18n.hasResourceBundle(lng, 'subscriptions') &&
    i18n.hasResourceBundle(lng, 'paymentHistory') &&
    i18n.hasResourceBundle(lng, 'invoiceData')
  );
};
